import styled from '@emotion/styled';
import {fonts, colors, mq} from 'ui/config';
import mask from 'assets/img/mask.png';

export const textStyle = {
  fontSize: 13,
  lineHeight: '16px',
};

export const Text = styled('div')(textStyle);

export const Error = styled(Text)({
  color: colors.beige,
  marginTop: 8,
});

export const FormError = styled(Error)({
  backgroundImage: `url(${mask})`,
  marginBottom: 25,
  fontSize: 15,
  padding: 8,
  borderRadius: 7,
});

export const FormErrorWhite = styled(FormError)({
  backgroundColor: colors.greyLight,
  backgroundImage: 'none',
  marginBottom: 25,
  fontSize: 15,
  padding: 8,
  borderRadius: 7,
  color: '#A10F00',
});

export const FormSuccess = styled(FormError)({
  backgroundColor: colors.greyLight,
  backgroundImage: 'none',
  marginBottom: 32,
  fontSize: 17,
  padding: 17,
  borderRadius: 7,
  color: '#066731',
  textAlign: 'center',
  lineHeight: 1.4,
});

export const MainTitle = styled('h1')({
  ...textStyle,
  fontSize: 30,
  lineHeight: 1.1,
  color: colors.white,
  fontFamily: fonts.title,
  fontWeight: 'bold',
  margin: 0,
  textAlign: 'center',
  paddingLeft: 20,
  paddingRight: 20,
  [mq('small')]: {
    paddingLeft: 5,
    paddingRight: 5,
    fontSize: 30,
  },
});

export const MainTitleDark = styled(MainTitle)({
  color: colors.black,
});

export const FormTitle = styled('div')({
  ...textStyle,
  fontSize: 16,
  lineHeight: '19px',
  color: colors.darkBrown,
  fontWeight: 'bold',
  fontFamily: fonts.title,
  marginBottom: 24,
  marginTop: 22,
});

export const SmallTitle = styled('div')({
  fontSize: 11,
  lineHeight: '26px',
  color: colors.beige,
  textTransform: 'uppercase',
  letterSpacing: 2,
  textAlign: 'center',
});

export const Headline = styled('div')({
  fontSize: 18,
  lineHeight: '24px',
  fontWeight: '500',
  color: colors.white,
  textAlign: 'center',
});

export const HeadlineMedium = styled(Headline)({
  fontSize: 16,
  lineHeight: '22px',
  marginBottom: 45,
  fontWeight: 'regular',
  marginTop: 8,
});

export const HeadlineSmall = styled(Headline)({
  fontSize: 13,
  lineHeight: '16px',
  maxWidth: 296,
  marginBottom: 32,
  marginTop: 8,
});

export const LogoText = styled('div')({
  fontFamily: fonts.alt,
  fontSize: 40,
  fontWeight: '500',
  color: colors.white,
  margin: 0,
});

export const Link = styled('a')({
  fontSize: 14,
  lineHeight: '22px',
  color: colors.caramel,
  textAlign: 'center',
  textDecoration: 'underline',
  fontWeight: 400,
});

export const HrLine = styled('div')({
  display: 'flex',
  backgroundImage: 'linear-gradient(269deg, #B07F51 0%, #F2D6AD 50%, #B07F51 100%)',
  width: 44,
  height: 1,
  maxHeight: 1,
  // backgroundColor: colors.darkBrown,
  // paddingTop: 24,
  // paddingBottom: 18,
});

export const Hr = styled('span')({
  display: 'inline-block',
  width: '100vw',
  margin: 0,
  height: 4,
  backgroundImage: 'linear-gradient(269deg, #B07F51 0%, #F2D6AD 50%, #B07F51 100%)',
  marginBottom: 40,
});

export const TextSmall = styled('div')({
  fontSize: 12,
  lineHeight: '16px',
  color: colors.grey,
  marginBottom: 24,
});
